// this is a wrapper to avoid using new everywhere, and to bundle the css
// could also implement site-wide defaults here

import Flickity from 'flickity';
import 'flickity/css/flickity.css';
import assign from 'lodash/assign';
import {findClosest} from './miscellaneous';

export function flickity (el, options) {
  const defaults = {
    // dragThreshold: 10,
    // selectedAttraction: 0.025,
    // friction: 0.28
  };

  return new Flickity(el, assign(defaults, options));
}

export function flickityTriggers (flkty, triggerWrapper) {
  const updateCurrentState = () => {
    // let index = flkty.selectedIndex;

    if (triggerWrapper.querySelector('.is-selected')) {
      // strip from year and trigger
      triggerWrapper.querySelectorAll('.is-selected').forEach((el) => {
        el.classList.remove('is-selected');
      });
    }
    const currentTrigger = triggerWrapper
      .querySelector('.gallery-triggers a[href="#' + flkty.selectedElement.id + '"]');
    currentTrigger.classList.add('is-selected');
    const closestYear = findClosest(currentTrigger, '.year');
    closestYear.classList.add('is-selected');
  };

  const updateGalleryItem = (el) => {
    const targetId = el.getAttribute('href').slice(1);
    flkty.getCellElements().forEach((el, index) => {
      if (el.id === targetId) {
        flkty.select(index);
      }
    });

    // let a = Array.prototype.slice.call(triggerWrapper.querySelectorAll('.gallery-triggers a'));
    // let index = a.indexOf(el);
    // flkty.select(index);
  };

  updateCurrentState();
  flkty.on('select', updateCurrentState);

  triggerWrapper.querySelectorAll('.gallery-triggers a').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      updateGalleryItem(el);
    });
  });
}



// WEBPACK FOOTER //
// ./assets/j/util/flickity.js